import React, { useContext } from 'react'
import BootstrapDataContext from '@/context/BootstrapDataContext'
import { AppDownloadBannerContentType } from './types'
import { getPropsForAppBanner } from './utils'
import AppBannerSquareEdges from './AppBannerSquareEdges'
import AppBannerRounded from './AppBannerRounded'

const AppBannerWrapper = ({
  content,
  isRoundedBanner = false,
  ...props
}: {
  content: AppDownloadBannerContentType
  isRoundedBanner?: boolean
} & Record<string, unknown>) => {
  const bootstrapData = useContext(BootstrapDataContext)

  const AppBannerComponent = isRoundedBanner
    ? AppBannerRounded
    : AppBannerSquareEdges

  return (
    <AppBannerComponent
      {...{
        ...getPropsForAppBanner(bootstrapData),
        ...content,
        ...props
      }}
    />
  )
}

export default AppBannerWrapper
